angular.module('rjmNg.directives').directive "restrictionset", [
  () ->
    restrict: "E"
    templateUrl: "directive.restrictionSet.html"
    replace: true
    scope:
      restrictionSet: "="
      columns: "="
      isValid: "="
      metric: "<" # GA only
      filterSetsSupported: "@"
      filtersBlocked: "@"
      tableIds: "="
      rightColumnFilterSupported: "=?"
      showHelpLink: "=?"
    controller: [
      "$scope"
      "operatorEnums"
      "restrictionSetService"
      (
        $scope
        operatorEnums
        restrictionSetService
      ) ->

        $scope.rightColumnFilterSupported ?= false
        $scope.showHelpLink ?= false
        $scope.deleteRestrictionByIndex = (index) ->
          $scope.restrictionSet.restrictions.splice(index, 1)

          if $scope.restrictionSet.restrictions.length is 0
            # if there are no more restrictions, then set syntaxTree, string, and errorMessage to default
            $scope.restrictionSet.sequence.syntaxTree = null
            $scope.restrictionSet.sequence.string = null
            $scope.restrictionSet.sequence.errorMessage = null
          else
            # Make sure our sequence string is up to date before we alter it
            $scope.restrictionSet.sequence.syntaxTree =
              restrictionSetService.parseSequenceString(
                $scope.restrictionSet.sequence.string
              )

            # Remove the index from the syntaxTree
            $scope.restrictionSet.sequence.syntaxTree =
              restrictionSetService.removeIndexFromSyntaxTree(
                $scope.restrictionSet.sequence.syntaxTree
                index
              )

            # Now update our string with the latest copy of the syntaxTree
            $scope.restrictionSet.sequence.string =
              restrictionSetService.syntaxTreeToString(
                $scope.restrictionSet.sequence.syntaxTree
              )

          $scope.updateIsValid()
          $scope.$emit('restrictionChanged')

        addRestrictionToRestrictionSet = (restriction) ->
          $scope.restrictionSet.restrictions.push(restriction)
          restrictionSetService.addSequenceTerm($scope.restrictionSet)
          $scope.updateIsValid()
          $scope.$emit('restrictionChanged')

        # Get the column at the first position in the list when sorted
        # alphabetically by name.
        getFirstColumnByAlphabeticName = () ->
          column = _($scope.columns).reduce (column, memo) ->
            # Return the column whose name occurs first when compared
            # alphabetically
            if column.name.toLowerCase() < memo.name.toLowerCase() then column else memo

        $scope.addRestriction = () ->
          column = getFirstColumnByAlphabeticName()

          addRestrictionToRestrictionSet
            left:
              column_id: column.column_id
              name: column.name
              datatype: column.datatype
            op: operatorEnums.COMPARISON_OPERATOR_IDS['=']
            right: null

        $scope.addFilterSet = () ->
          addRestrictionToRestrictionSet
            filter_set_id: null

        # Returns true if the specified item is a filter set (as opposed to a
        # restriction).
        $scope.isFilterSet = (restriction) ->
          restriction.hasOwnProperty('filter_set_id')

        nullWarningOperators = [
          operatorEnums.COMPARISON_OPERATOR_IDS['!='],
          operatorEnums.COMPARISON_OPERATOR_IDS['NOT LIKE'],
          operatorEnums.COMPARISON_OPERATOR_IDS['NOT IN']
        ]

        wildcardWarningOperators = [
          operatorEnums.COMPARISON_OPERATOR_IDS['LIKE'],
          operatorEnums.COMPARISON_OPERATOR_IDS['NOT LIKE']
        ]

        $scope.updateIsValid = ->
          $scope.isValid = restrictionSetService.restrictionSetIsValid(
            $scope.restrictionSet
          )

          $scope.showNullWarning = false
          $scope.showWildcardWarning = false
          for restriction in $scope.restrictionSet.restrictions
            if restriction.op in nullWarningOperators
              $scope.showNullWarning = true
            if restriction.op in wildcardWarningOperators
              $scope.showWildcardWarning = true

        $scope.$on 'updateIsValid', (event) ->
          $scope.updateIsValid()

        $scope.updateSyntaxTree = () ->
          restrictionSetService.validateAndUpdateSyntaxTree(
            $scope.restrictionSet
          )
          $scope.updateIsValid()

        # Set the proper datatype for each column by cross-referencing the
        # columns property.
        $scope.updateDatatypes = () ->
          return unless $scope.columns? and $scope.restrictionSet?.restrictions?

          for restriction in $scope.restrictionSet.restrictions when restriction?
            continue if $scope.isFilterSet(restriction) or
              restriction.left?.datatype?

            column = _.find $scope.columns, (column) ->
              +column.column_id is +restriction.left.column_id

            if column?
              restriction.left.datatype = column.datatype

    ]
    link: (scope, elem, attrs) ->

      scope.$watch "restrictionSet.sequence.string", (string, old) ->
        if string is old or not scope.restrictionSet?.sequence?.string?
          return

        scope.updateSyntaxTree()

      scope.$watch "restrictionSet.restrictions", scope.updateIsValid, true

      # In the case where restrictions do not have a datatype set this watch
      # sets the proper datatype by cross referencing the columns property
      scope.$watch "columns", (columns, old) ->
        if columns isnt old
          scope.updateDatatypes()

      scope.updateSyntaxTree()

  ]
